export default __webpack_public_path__ + "static/B0156-674e5eb7a61d83efd65132454f9502f5.png";